const booleanType = {

    /**
     * Encodes a boolean into a boolean.
     *
     * @param {bool} val - A boolean.
     * @returns {bool}
     */
    encode(val) {
        return val ? 1 : 0;
    },

    /**
     * Decodes a boolean param from the URL into a boolean.
     *
     * @param {string} val - A boolean.
     * @returns {bool}
     */
    decode(val) {
        return val === true ? true : val === 'true';
    },

    equals(a, b) {
        return this.is(a) && a === b;
    },

    is(val) {
        return [true, false, 0, 1].indexOf(val) >= 0;
    },
};

module.exports = { booleanType };



// WEBPACK FOOTER //
// ./src/configuration/booleanparamtype.js